var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportingclient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 383.9069 364.2644",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab1547dc-cad2-434d-b59d-9fcda1a25b3c",
    x1: 228.2208,
    y1: 291.2622,
    x2: 413.8024,
    y2: 291.2622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0065ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c9aff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "a4176d1d-a74c-41b4-a66c-86fc6ff944cc",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.871,388.7688c-38.514,50.0868-93.0212,96.1624-172.485,54.7274-64.6739-33.7231-48.5118-113.1733-76.9093-134.0186-22.209-16.3024-23.6553-2.503-56.303-22.1793-39.6312-23.8853-48.9777-65.839-29.317-110.3439,27.7664-62.8531,83.3622-95.7877,130.9949-75.8531,60.3291,25.2483,50.5752,48.4076,75.4563,63.0637,29.3432,17.2844,47.8506-14.5513,114.9951,21.3909C476.2353,229.4138,447.4187,337.3375,407.871,388.7688Z",
    transform: "translate(-62.9116 -95.2999)",
    style: {
      fill: "#f4f5f7",
      opacity: 0.73
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.0072,264.191a3.4842,3.4842,0,0,1-3.474-3.2168h0c-.7422-6.6811,1.4849-13.9809,7.6711-21.4042,5.5674-6.5575,8.6605-11.3827,8.6605-16.95,0-6.31-3.9591-10.5165-11.7536-10.64a23.5159,23.5159,0,0,0-9.7064,2.1683,2.9723,2.9723,0,0,1-4.0469-1.6331l-1.7123-4.4945c4.0831-2.9693,11.1352-4.9489,17.6927-4.9489,14.2282,0,20.6617,8.7844,20.6617,18.1874,0,8.4132-4.7015,14.4756-10.64,21.528-5.4439,6.4336-7.4235,11.8776-7.0523,18.1875l.1237,3.2168Z",
    transform: "translate(-62.9116 -95.2999)",
    style: {
      fill: "#ffab00"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191.8245,
    cy: 276.2651,
    r: 7.1641,
    transform: "translate(-184.5133 302.9612) rotate(-76.4935)",
    style: {
      fill: "#ffab00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.4063,237.08h0a13.12,13.12,0,0,1-9.77-15.77l6.22-26.49a1.24,1.24,0,0,1,1.2-1l5.17.28,19.4,5.72-6.43,27.49a13.12,13.12,0,0,1-15.7712,9.7744Z",
    transform: "translate(-62.9116 -95.2999)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.4718,303.7641H180.6605a46.9693,46.9693,0,0,0-17.4548,3.92l-35.6369,16.828-.0324-5.7683a15.11,15.11,0,0,0-15.0653-14.98l-4.3171.091L108.0683,187.1H278.6276l.0212,27.7159h7.5361V187.0189a7.5,7.5,0,0,0-7.4768-7.4761h-170.64a7.5039,7.5039,0,0,0-7.4767,7.4761V303.8551a7.4939,7.4939,0,0,0,7.4767,7.46h4.4028a7.5574,7.5574,0,0,1,7.514,7.4767l.0533,10.1328c.0268,3.0745,1.7516,4.9276,4.1778,4.9276a6.193,6.193,0,0,0,2.63-.6482L166.43,314.5072a39.7744,39.7744,0,0,1,14.2305-3.1918h51.8113Z",
    transform: "translate(-62.9116 -95.2999)",
    style: {
      fill: "#ffab00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.3311,214.11a7.4912,7.4912,0,0,1,7.4713,7.4712V338.4177a7.49,7.49,0,0,1-7.4713,7.4658H401.94a7.5639,7.5639,0,0,0-7.525,7.4816l-.0538,10.1224c-.0267,4.1028-3.09,6.0311-6.8016,4.2794L347.975,349.0753a39.7727,39.7727,0,0,0-14.23-3.1918H235.6974a7.4947,7.4947,0,0,1-7.4766-7.4658V221.5815a7.4957,7.4957,0,0,1,7.4766-7.4712Z",
    transform: "translate(-62.9116 -95.2999)",
    style: {
      fill: "url(#ab1547dc-cad2-434d-b59d-9fcda1a25b3c)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.109 204.883 223.076 175.85 232.995 165.937 252.109 185.051 283.205 153.243 293.124 163.162 252.109 204.883",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.1963,235.58h0a13.7,13.7,0,0,0,8.3211-17.4968l-.0011-.0032-1.34-4h-29.21l4.69,13.21a13.7,13.7,0,0,0,17.5058,8.3023Z",
    transform: "translate(-62.9116 -95.2999)",
    style: {
      fill: "#dfe1e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.2271,194.151l23.14,5.436a1.24,1.24,0,0,1,.9117,1.498l-.0025.01-6.1746,26.2845a13.12,13.12,0,0,1-15.7453,9.655h0a13.12,13.12,0,0,1-9.7719-15.7727l6.1472-26.1676a1.24,1.24,0,0,1,1.4757-.9475Z",
    transform: "translate(-62.9116 -95.2999)",
    style: {
      fill: "#ffab00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.7263,229.3a6.51,6.51,0,1,1,6.2906-4.91A6.52,6.52,0,0,1,283.7263,229.3Zm0-10.88a4.6342,4.6342,0,1,1-.02,0Z",
    transform: "translate(-62.9116 -95.2999)",
    style: {
      fill: "#0052cc"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportingclient);
export default __webpack_public_path__ + "static/media/supportingclient.f4a11cc6002820a250c460cc5125b294.svg";
export { ForwardRef as ReactComponent };